export const StudioDisclaimerContent =
  "All renderings, illustrations, photographs, floor plans, images, and\n" +
  'drawings of homes on Villa\'s website (collectively, "Renderings") are\n' +
  "for illustrative purposes only and subject to change at any time and\n" +
  "for any reason. Villa makes no representation or warranty that homes\n" +
  "will be the same as such Renderings.";
